export const FRAME_EVENT_PREFIX = "__SAMOOHA__";
export const FRAME_TITLE_PREFIX = "webapp.";

export enum FRAME_EVENT {
    FEATURE_CTX_SYNC = "FEATURE_CTX_SYNC",
    SHOW_TOAST = "SHOW_TOAST",
    SHOW_PROGRESS_LOADER = "SHOW_PROGRESS_LOADER",
    HIDE_PROGRESS_LOADER = "HIDE_PROGRESS_LOADER",
    START_PROGRESS_BAR = "START_PROGRESS_BAR",
    STOP_PROGRESS_BAR = "STOP_PROGRESS_BAR",
    UPDATE_PROGRESS_BAR = "UPDATE_PROGRESS_BAR",
    MANAGE_HELP = "MANAGE_HELP",
    TOGGLE_HELP = "TOGGLE_HELP",
    SHOW_MODAL = "SHOW_MODAL",
    DIMISS_MODAL = "DISMISS_MODAL",
    // Global Reset event to reset any overlay
    RESET = "RESET",
    RELOAD_WINDOW = "RELOAD_WINDOW",
    USER_LOGGEDIN_STATUS = "USER_LOGGEDIN_STATUS",
    NAVIGATE_TO_URL = "NAVIGATE_TO_URL",
}
